<template>
  <footer class="footer">
    <div class="container">
      <!-- Footer Content -->
      <div class="footer-content">
        <!-- Company Info -->
        <div class="footer-section">
          <h3 class="footer-title">Modern Kurs</h3>
          <p class="footer-description">
            Modern Kurs, eğitimde kaliteyi ve yeniliği bir araya getiren, öğrencilerin potansiyellerini en üst düzeye çıkarmalarına yardımcı olan bir eğitim kurumudur.
          </p>
          <div class="social-links">
            <a href="https://facebook.com/modern.kurs.7" class="social-link" title="Facebook" target="_blank">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="https://twitter.com/kursmodern?s=21" class="social-link" title="Twitter" target="_blank">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://instagram.com/modern_kurs" class="social-link" title="Instagram" target="_blank">
              <svg class="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="https://youtube.com/@modernkurs2739" class="social-link" title="YouTube" target="_blank">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>
        </div>
        
                  <!-- Quick Links -->
          <div class="footer-section">
            <h3 class="footer-title">Hızlı Linkler</h3>
            <ul class="footer-links">
              <li><router-link to="/" class="footer-link" @click="scrollToTop">Ana Sayfa</router-link></li>
              <li><router-link to="/about" class="footer-link" @click="scrollToTop">Hakkımızda</router-link></li>
              <li><router-link to="/contact" class="footer-link" @click="scrollToTop">İletişim</router-link></li>
              <li><router-link to="/blogs" class="footer-link" @click="scrollToTop">Blog</router-link></li>
              <li><router-link to="/login" class="footer-link" @click="scrollToTop">Modern Randevu Sistemi</router-link></li>
            </ul>
          </div>
        
        <!-- Services -->
        <div class="footer-section">
          <h3 class="footer-title">Hizmetlerimiz</h3>
          <div class="footer-services-grid">
            <ul class="footer-links">
              <li><a class="footer-link">TYT-AYT Hazırlık</a></li>
              <li><a class="footer-link">Online Eğitim</a></li>
              <li><a class="footer-link">Kişisel Takip</a></li>
              <li><a class="footer-link">Kütüphane</a></li>
              <li><a class="footer-link">Veli Bilgilendirme</a></li>
              <li><a class="footer-link">Deneme Sınavı</a></li>
            </ul>
            <ul class="footer-links">
              <li><a class="footer-link">Etkinlikler</a></li>
              <li><a class="footer-link">Seri Denemeler</a></li>
              <li><a class="footer-link">Kariyer Danışmanlığı</a></li>
              <li><a class="footer-link">Konferanslar</a></li>
              <li><a class="footer-link">Ekstra Kaynak Kitap</a></li>
              <li><a class="footer-link">İnternet</a></li>
            </ul>
          </div>
        </div>
        
        <!-- Contact Info -->
        <div class="footer-section">
          <h3 class="footer-title">İletişim</h3>
          <div class="footer-contact">
            <div class="contact-item">
              <span class="contact-icon">📍</span>
              <a href="https://www.google.com/maps?q=37.461503125207315,35.82148209864696" target="_blank" class="contact-link address-link">
                Modern Kurs Merkezi, Göç Yolu Yusuf Baysal Sitesi Edem Pastanesi Üstü, Tufanpaşa, Kozan/Adana
              </a>
            </div>
            <div class="contact-item">
              <span class="contact-icon">📞</span>
              <div class="phone-numbers">
                <a href="tel:05526833403" class="contact-link phone-link">0552 683 34 03</a>
                <span class="phone-separator">-</span>
                <a href="tel:05526833409" class="contact-link phone-link">0552 683 34 09</a>
              </div>
            </div>
            <div class="contact-item">
              <span class="contact-icon">☎️</span>
              <a href="tel:03225150405" class="contact-link phone-link">0322 515 04 05</a>
            </div>
            <div class="contact-item">
              <span class="contact-icon">📧</span>
              <a href="mailto:modernkurs01@gmail.com" class="contact-link email-link">modernkurs01@gmail.com</a>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <p>&copy; 2025 Modern Kurs. Tüm hakları saklıdır. Bu site Modern Kurs öğrencileri tarafından yapılmıştır. (<a href="https://www.linkedin.com/in/do%C4%9Fan-co%C5%9Fman-042b3529b/" target="_blank" class="developer-link">Doğan Coşman</a> | <a href="https://www.linkedin.com/in/bilal-said-yilmaz/" target="_blank" class="developer-link">Bilal Said Yılmaz</a>)</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'CorporateFooter',
  setup() {
    const scrollToTop = () => {
      // Sayfa en üstüne git
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    
    return {
      scrollToTop
    }
  }
}
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  color: white;
  padding: 4rem 0 0;
  margin-top: 0;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse"><path d="M 20 0 L 0 0 0 20" fill="none" stroke="rgba(255,255,255,0.03)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.5;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 4rem;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.footer-section {
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.02);
  padding: 2rem;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.footer-section:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-5px);
}


.footer-description {
  color: #bdc3c7;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.social-link svg {
  width: 20px;
  height: 20px;
}

.social-link:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: translateY(-3px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
}

.footer-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #ecf0f1;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 0.8rem;
}

.footer-services-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.footer-link {
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s ease;
  display: inline-block;
}

.footer-link:hover {
  color: #667eea;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
}

.contact-icon {
  font-size: 1.2rem;
  margin-top: 0.2rem;
}

.contact-item p {
  color: #bdc3c7;
  line-height: 1.5;
  margin: 0;
}

.contact-link {
  color: #bdc3c7;
  text-decoration: none;
  line-height: 1.5;
  margin: 0;
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-block;
}

.contact-link:hover {
  color: #667eea;
  transform: translateX(5px);
}

.phone-numbers {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.phone-separator {
  color: #bdc3c7;
  font-weight: 400;
  font-size: 0.9rem;
}

.address-link:hover {
  color: #667eea;
  text-decoration: underline;
}

.phone-link:hover {
  color: #667eea;
  text-decoration: underline;
}

.email-link:hover {
  color: #667eea;
  text-decoration: underline;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 2rem;
  position: relative;
  z-index: 10;
  background: rgba(0, 0, 0, 0.2);
  margin: 0 -2rem -2rem -2rem;
  padding: 2rem;
  border-radius: 0 0 20px 20px;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  position: relative;
  z-index: 11;
}

.footer-bottom p {
  color: #95a5a6;
  margin: 0;
}

.footer-bottom-links {
  display: flex;
  gap: 2rem;
  justify-content: center;
}

.footer-bottom-link {
  color: #95a5a6;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.footer-bottom-link:hover {
  color: #667eea;
}

.developer-link {
  color: #95a5a6;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  border-bottom: 1px solid transparent;
  cursor: pointer;
  position: relative;
  z-index: 10;
  display: inline-block;
}

.developer-link:hover {
  color: #667eea;
  border-bottom-color: #667eea;
  transform: translateY(-1px);
  text-decoration: underline;
}

/* Container */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* Responsive */
@media (max-width: 1200px) {
  .container {
    max-width: 1000px;
    padding: 0 2rem;
  }
  
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem;
  }
  
  .footer-section {
    padding: 2rem;
  }
}

@media (max-width: 768px) {
  .container {
    max-width: 100%;
    padding: 0 1.5rem;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
  
  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
  }
  
  
  
  .footer-section {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 3rem 0 0;
  }
  
  .container {
    max-width: 100%;
    padding: 0 1rem;
  }
  
  .social-links {
    justify-content: center;
  }
}
</style>
